import { CircuitoTomoData } from "./CircuitoTomoData";
import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setCircuitoTomo } from "../../../context/Actions/turnos/estudioTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import HeaderModal from "../headerModal/headerModal";
import "./Circuito.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const CircuitoTomo = ({
  titulo,
  dissmiss,
  danger,
  texto,
  completarFormulario,
}) => {
  const { estudioTurnosDispatch, estudioTurnosState } =
    useContext(PortalContext);

  // Toaster Global
  const { authState, toasterDispatch, toasterState } = useContext(GlobalContext);

  const [circuitoFiltrado, setCircuitoFiltrado] = useState(CircuitoTomoData);
  const [refer, setRefer] = useState(false);

  useEffect(() => {
    // Si es femenino agrego las preguntas sobre embarazo
    if (authState?.auth?.data?.paciente?.sexo === "F") {
      let newObj = [
        {
          pregunta: `¿Usted está embarazada o tiene la sospecha de estarlo?`,
          name: "embarazada",
          valor: null,
          visible: false,
          key: 8,
        },
        {
          pregunta: `¿Usted está amamantando?`,
          name: "amamantando",
          valor: null,
          visible: false,
          key: 9,
        },
      ];
      setCircuitoFiltrado([...circuitoFiltrado, ...newObj]);
    }
  }, []);

  const onChangeRadio = (e) => {
    const { name, value } = e.target;
    const checked = value === "true";

    let x = { ...estudioTurnosState.estudioTurnos.circuitoTomo };
    let arrX = [...circuitoFiltrado];

    // Reglas de dependencias
    const rules = {
      conContraste: {
        true: {
          updateState: { conContraste: true },
          updateArr: [
            { name: "insRenal", visible: true },
            { name: "diabetico", visible: true },
            { name: "hipertenso", visible: true },
            { name: "contrasteReciente", visible: true },
            { name: "embarazada", visible: true },
            { name: "amamantando", visible: true },
          ],
        },
        false: {
          updateState: { conContraste: false },
          updateArr: [
            { name: "insRenal", visible: false, valor: null },
            { name: "funcionRenal", visible: false, valor: null },
            { name: "diabetico", visible: false, valor: null },
            { name: "hipertenso", visible: false, valor: null },
            { name: "contrasteReciente", visible: false, valor: null },
            { name: "embarazada", visible: false, valor: null },
            { name: "amamantando", visible: false, valor: null },
          ],
        },
      },
      insRenal: {
        true: {
          updateState: { insRenal: true },
          updateArr: [{ name: "labFuncionRenal", visible: true }],
        },
        false: {
          updateState: { insRenal: false, labFuncionRenal: false },
          updateArr: [{ name: "labFuncionRenal", visible: false, valor: null }],
        },
      },
    };

    // Aplicar la regla si existe
    if (rules[name]) {
      const rule = rules[name][value];
      if (rule.updateState) {
        x = { ...x, ...rule.updateState };
      }
      if (rule.updateArr) {
        arrX = arrX.map((item) => {
          const found = rule.updateArr.find((r) => r.name === item.name);
          return found ? { ...item, ...found } : item;
        });
      }
    } else {
      // Caso genérico (no tiene reglas)
      x = { ...x, [name]: checked };
    }

    // Siempre actualizamos el valor del item actual
    arrX = arrX.map((item) =>
      item.name === name ? { ...item, valor: checked } : item
    );

    setCircuitoTomo(x)(estudioTurnosDispatch);
    setCircuitoFiltrado(arrX);
  };

  const onChangeInput = (e) => {
    const { name, value } = e.target;
    setCircuitoFiltrado((prev) =>
      prev.map((item) =>
        item.name === name ? { ...item, valor: value } : item
      )
    );
  };

  const onClickVolverCirc = () => {
    setCircuitoFiltrado(CircuitoTomoData);
    dissmiss();
  };

  const onClickBusqCirc = () => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoTomo);
    let arrX = circuitoFiltrado;
    arrX = arrX.filter((item) => (item.visible === true ? item : ""));
    arrX = arrX.filter((item) => item.valor === null);
    if (arrX.length > 0) {
      showToaster(
        {
          texto: "Complete las preguntas!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      setCircuitoFiltrado(CircuitoTomoData);
      // completarFormulario("TOMO", x);
      setCircuitoTomo({
        ...x,
        flgForm: true,
      })(estudioTurnosDispatch);
    }
  };

  let modalAutoScroll = document.documentElement.getElementsByClassName(
    "ptur-circuito-boxTomo"
  );

  useEffect(() => {
    if (refer) {
      modalAutoScroll[0].scrollTo({ top: 200, behavior: "smooth" });
    }
    if (toasterState.toaster.show) {
      window.scrollTo({ top: 380, behavior: "smooth" });
      setRefer(false);
    }
  }, [refer]);

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />
      <div className="ptur-circuitoTomo-bodyModal">
        <div className="ptur-circuito-tituloDesc">
          <p className="rb18l titulo-circuito">{texto}</p>
        </div>
        <div className="ptur-circuito-boxTomo">
          {circuitoFiltrado.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.visible && (
                  <div className="ptur-circuito-boxPreguntas">
                    <div className="ptur-circuito-preguntaDesc">
                      <span className="rb14l">{item.pregunta}</span>
                    </div>
                    {item.input ? (
                      <div className="ptur-circuito-input">
                        <input
                          type="number"
                          name={item.name}
                          onChange={(e) => onChangeInput(e)}
                          value={item.valor}
                          className={"ptur-input-peso inputNonScroll"}
                        />
                        <p>kg</p>
                      </div>
                    ) : (
                      <div className="ptur-circuito-radios">
                        <span>
                          <InputV1
                            name={item.name}
                            nombreRadio={item.name}
                            onChange={onChangeRadio}
                            value={true}
                            inputType="radio"
                            labelStr={"Sí"}
                            radioClass="ptur-circuito-radio"
                            noHeight={true}
                          />
                        </span>
                        <span>
                          <InputV1
                            name={item.name}
                            nombreRadio={item.name}
                            onChange={onChangeRadio}
                            value={false}
                            inputType="radio"
                            labelStr={"No"}
                            radioClass="ptur-circuito-radio"
                            noHeight={true}
                          />
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="ptur-circuito-boxBtn">
          <button
            className="ptur-circuito-btnVolver c-latex30 rb16m"
            onClick={onClickVolverCirc}
          >
            Volver
          </button>
          <button
            className="ptur-circuito-btnBusq c-white rb16m"
            onClick={onClickBusqCirc}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </>
  );
};

export default CircuitoTomo;
